import React from "react";
import * as FeatherIcon from "react-feather";
import "./AutoNurtureHelperCard.css";

export default function AutoNurtureHelperCard() {
  return (
    <div className="auto-helper-card">
      <div className="auto-helper-header">
        <div className="auto-helper-header-left">
          {/* <span className="auto-helper-dot" /> */}
          <h5 className="auto-helper-title">What is Auto-Nurture?</h5>
        </div>
       
      </div>

      <p className="auto-helper-intro">
        Auto-Nurture helps you **automate personalized email campaigns**,
        ensuring that your prospects and customers receive the right message at
        the right time — without manual follow-ups.
      </p>

    

     
    </div>
  );
}
